import { render, staticRenderFns } from "./ProcessSection.vue?vue&type=template&id=3bf1f6df"
import script from "./ProcessSection.vue?vue&type=script&lang=js"
export * from "./ProcessSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports